import { ImageName } from "@mcleod/images";
import { AutogenLayoutIntercompanyDetail } from "./autogen/AutogenLayoutIntercompanyDetail";
import { ComponentProps, HorizontalSpacer, Label, Image, Panel } from "@mcleod/components";
import { HorizontalAlignment, ModelRow, StringUtil } from "@mcleod/core";
import { CLEARED_STATUS_CODE } from "@mcleod/dispatch/src/Movement";
import { IntercompanyBrokerageInfo } from "./IntercompanyBrokerageInfo";
import { IntercompanyAssetInfo } from "./IntercompanyAssetInfo";

export class IntercompanyDetail extends AutogenLayoutIntercompanyDetail {
    private _sharedStops: ModelRow[];
    private _shipperStopId: string;
    private _consigneeStopId: string;
    private _movementId: string;
    private _isBrokerage: boolean;
    private _ediOrderId: string;
    private _ops_name: string;
    private _ops_phone: string;
    private _ops_ext: string;
    private _ops_email: string;
    private _dis_name: string;
    private _dis_phone: string;
    private _dis_ext: string;
    private _dis_email: string;
    private _driver: string;
    private _driverPhone: string;
    private _driverEmail: string;
    private _driver2: string;
    private _driver2Phone: string;
    private _driver2Email: string;
    private _carrierName: string;
    private _carrierContact: string;
    private _carrierPhone: string;
    private _carrierEmail: string;
    private _tractor: string;
    private _trailer: string;
    private _trailerType: string;

    public setIntercompanyData() {
        this.setStops(this.sharedStops);

        if (this.sharedStops?.length > 0) {
            for (let i = 0; i < this.sharedStops.length; i++) {
                const stop = this.sharedStops[i];
                const stopId = stop["ss_stop_id"];
                if (stopId === this.shipperStopId) {
                    this.fillShipperStopInfo(stop);
                }
                if (stopId === this.consigneeStopId) {
                    this.fillConsigneeStopInfo(stop);
                }
            }
        }

        this.labelOUName.text = this.ops_name;
        this.labelOUPhone.text = this.ops_phone;
        if (!StringUtil.isEmptyString(this.ops_ext) && !StringUtil.equalsIgnoreCase("undefined", this.ops_ext)) this.labelOUExt.text = "ext: " + this.ops_ext;
        this.labelOUEmailAddress.text = this.ops_email;
        this.labelDisUserName.text = this.dis_name;
        this.labelDisPhone.text = this.dis_phone;
        if (!StringUtil.isEmptyString(this.dis_ext) && !StringUtil.equalsIgnoreCase("undefined", this.dis_ext)) this.labelDUExt.text = "ext: " + this.dis_ext;
        this.labelDisEmail.text = this.dis_email;
        this.isBrokerage? this.fillBrokerageInfo() : this.fillAssetInfo();
    }

    fillBrokerageInfo() {
        this.layoutICAsset.visible = false;
        const brokerageLayout = this.layoutICBrokerage as IntercompanyBrokerageInfo;
        this.labelEquipment.text = "Carrier Combination";
        this.labelDispatcher.text = "Carrier Sales Rep";
        brokerageLayout.labelBrTractorValue.text = this.tractor;
        brokerageLayout.labelBrTrailerValue.text = this.trailer;
        brokerageLayout.labelBrTrailerTypeValue.text = this.trailerType;
        brokerageLayout.labelCarrierNameValue.text = this.carrierName;
        brokerageLayout.labelBrCarContactValue.text = this.carrierContact;
        brokerageLayout.labelBrCarEmailValue.text = this.carrierEmail;
        brokerageLayout.labelBrCarPhoneValue.text = this.carrierPhone;
        brokerageLayout.labelBrDriver1Value.text = this.driver;
        brokerageLayout.labelBrDriver1PhoneValue.text = this.driverPhone;
        brokerageLayout.labelBrDriver1EmailValue.text = this.driverEmail;
        if(this.driver2) {
            brokerageLayout.labelBrDriver2Value.text = this.driver2;
            brokerageLayout.labelBrDriver2PhoneValue.text = this.driver2Phone;
            brokerageLayout.labelBrDriver2EmailValue.text = this.driver2Email;
        } else {
            brokerageLayout.labelBrDriver2.visible = false;
            brokerageLayout.labelBrDriver2Value.visible = false;
            brokerageLayout.labelBrDriver2Phone.visible = false;
            brokerageLayout.labelBrDriver2PhoneValue.visible = false;
            brokerageLayout.labelBrDriver2Email.visible = false;
            brokerageLayout.labelBrDriver2EmailValue.visible = false;
        }

    }

    fillAssetInfo() {
        this.layoutICBrokerage.visible = false;
        this.labelEquipment.text = "Equipment";
        this.labelDispatcher.text = "Dispatcher";
        const assetLayout = this.layoutICAsset as IntercompanyAssetInfo;
        assetLayout.labelAssetTractorValue.text = this.tractor;
        assetLayout.labelAssetTrailerValue.text = this.trailer;
        assetLayout.labelAssetDriverValue.text = this.driver;
        assetLayout.labelAssetDriver2Value.text = this.driver2;
    }

    fillShipperStopInfo(shipStop: ModelRow) {
        this.labelPULocationName.text = shipStop["ss_location_name"];
        this.labelPUAddress.text = shipStop["ss_address"];
        const cityStateZipText = shipStop["ss_city_name"] + ", " + shipStop["ss_state"] + " " + shipStop["ss_zip_code"];
        this.labelPUCityStateZip.text = cityStateZipText;
        this.labelPUSchedArriveEarly.text = shipStop["ss_arrive_early"] != null ? shipStop["ss_arrive_early"] : "--";
        this.labelPUSchedLate.text = shipStop["ss_arrive_late"] != null ? shipStop["ss_arrive_late"] : "--";
        this.labelPUActArrival.text = shipStop["ss_act_arrival"] != null ? shipStop["ss_act_arrival"] : "--";
        this.labelPUActDeparture.text = shipStop["ss_act_departure"] != null ? shipStop["ss_act_departure"] : "--";
        const shipStatus = shipStop["ss_status"];
        let searchStatus = shipStatus;

        if (shipStatus === "A") {
            if (shipStop["ss_act_arrival"] != null) {
                searchStatus = "R";
            }
        }

        switch (searchStatus) {
            case "A":
                this.labelPUStatusValue.visible = false;
                break;
            case "R":
                this.labelPUStatusValue.text = "Arrived";
                this.labelPUStatusValue.backgroundColor = "success";
                this.labelPUStatusValue.color = "default.reverse";
                break;
            case "D":
                this.labelPUStatusValue.text = "Departed";
                this.labelPUStatusValue.backgroundColor = "warning";
                this.labelPUStatusValue.color = "default.reverse";
                break;
        }
    }

    fillConsigneeStopInfo(consStop: ModelRow) {
        this.labelSOLocationName.text = consStop["ss_location_name"];
        this.labelSOAddress.text = consStop["ss_address"];
        const cityStateZipText = consStop["ss_city_name"] + ", " + consStop["ss_state"] + " " + consStop["ss_zip_code"];
        this.labelSOCityStateZip.text = cityStateZipText;
        this.labelSOSchedArriveEarly.text = consStop["ss_arrive_early"] != null ? consStop["ss_arrive_early"] : "--";
        this.labelSOSchedLate.text = consStop["ss_arrive_late"] != null ? consStop["ss_arrive_late"] : "--";
        this.labelSOActArrival.text = consStop["ss_act_arrival"] != null ? consStop["ss_act_arrival"] : "--";
        this.labelSOActDeparture.text = consStop["ss_act_departure"] != null ? consStop["ss_act_departure"] : "--";
        const consStatus = consStop["ss_status"];
        let searchStatus = consStatus;

        if (consStatus === "A") {
            if (consStop["ss_act_arrival"] != null) {
                searchStatus = "R";
            }
        }

        switch (consStatus) {
            case "A":
                this.labelSOStatusValue.visible = false;
                break;
            case "R":
                this.labelSOStatusValue.text = "Arrived";
                this.labelSOStatusValue.backgroundColor = "success";
                this.labelSOStatusValue.color = "default.reverse";
                break;
            case "D":
                this.labelSOStatusValue.text = "Delivered";
                this.labelSOStatusValue.backgroundColor = "warning";
                this.labelSOStatusValue.color = "default.reverse";
                break;
        }
    }

    setStops(stops: ModelRow[]) {
        this.layoutStopProgress.panelStopHeader.removeAll();
        const addSpacer = function (stopStatusPanel: Panel, props?: Partial<ComponentProps>) {
            if (props == null) props = {};
            props.fillHeight = true;
            stopStatusPanel.add(new HorizontalSpacer(props));
        }

        const addTopSpacer = function (stopStatusPanel: Panel, props: Partial<ComponentProps>) {
            if (props.borderBottomColor != null)
                props.borderBottomWidth = 3;
            props.height = 20;
            props.maxHeight = 20;
            addSpacer(stopStatusPanel, props);
        }

        let prevStopCleared = false;

        const smallFillerProps: Partial<ComponentProps> = { width: 75, fillRow: false };

        stops?.forEach((stop, index) => {
            const lastStop = index + 1 == stops.length;
            const stopCityState = stop["ss_city_name"] + ", " + stop["ss_state"];
            const cleared = stop["ss_status"] == CLEARED_STATUS_CODE;

            const stopStatusPanel = new Panel({
                fillHeight: true,
                fillRow: true,
                padding: 0,
                rowBreak: false,
                wrap: false
            });

            if (index == 0)
                addTopSpacer(stopStatusPanel, smallFillerProps);
            else if (stops.length == 3 || lastStop || index == 1)
                addTopSpacer(stopStatusPanel, { borderBottomColor: prevStopCleared ? "warning" : "strokeSecondary" });

            if (index == 0 || stops.length == 3 || lastStop)
                this.addStopBubble(cleared, stopStatusPanel, stop, index);
            else if (index == 1)
                this.addMoreStopsButton(stops, stopStatusPanel);

            if (lastStop)
                addTopSpacer(stopStatusPanel, { ...smallFillerProps, rowBreak: true });
            else if (index == 0 || index == 1)
                addTopSpacer(stopStatusPanel, {
                    rowBreak: true,
                    borderBottomColor: cleared ? "warning" : "strokeSecondary"
                });

            if (index == 0 || stops.length == 3 || lastStop)
                this.addCityStateInfo(addSpacer, stopStatusPanel, index, smallFillerProps, stopCityState, lastStop);

            prevStopCleared = stop["ss_act_departure"] != null;
        });
    }

    private addStopBubble(cleared: boolean, stopStatusPanel: Panel, stop: ModelRow<any>, index: number) {
        if (cleared) {
            stopStatusPanel.add(new Image({
                borderRadius: 50,
                color: "warning",
                height: 30,
                width: 30,
                marginTop: 5,
                rowBreak: false,
                name: ImageName.circleCheck
            }));
        } else {
            stopStatusPanel.add(new Label({
                align: HorizontalAlignment.CENTER,
                borderWidth: 3,
                borderColor: "strokeSecondary",
                borderRadius: 50,
                color: "subtle.darker",
                fontSize: "xlarge",
                height: 30,
                width: 30,
                marginTop: 5,
                rowBreak: false,
                text: (index + 1) + ""
            }));
        }
    }

    private addMoreStopsButton(stops: ModelRow[], stopStatusPanel: Panel) {
        this.layoutStopProgress.panelStopHeader.add(stopStatusPanel);
    }


    private addCityStateInfo(addSpacer: (stopStatusPanel: Panel, props?: Partial<ComponentProps>) => void, stopStatusPanel: Panel, index: number, smallFillerProps: Partial<ComponentProps>, stopCityState: string, lastStop: boolean) {
        addSpacer(stopStatusPanel, (index == 0) ? smallFillerProps : null);
        stopStatusPanel.add(new Label({ rowBreak: false, text: stopCityState, fontSize: "small", fontBold: true }));
        addSpacer(stopStatusPanel, lastStop ? smallFillerProps : null);
        this.layoutStopProgress.panelStopHeader.add(stopStatusPanel);
    }

    public get shipperStopId(): string {
        return this._shipperStopId;
    }

    public set shipperStopId(value: string) {
        this._shipperStopId = value;
    }

    public get consigneeStopId(): string {
        return this._consigneeStopId;
    }

    public set consigneeStopId(value: string) {
        this._consigneeStopId = value;
    }

    public get movementId(): string {
        return this._movementId;
    }

    public set movementId(value: string) {
        this._movementId = value;
    }

    public get ediOrderId(): string {
        return this._ediOrderId;
    }

    public set ediOrderId(value: string) {
        this._ediOrderId = value;
    }

    public get ops_name(): string {
        return this._ops_name;
    }

    public set ops_name(value: string) {
        this._ops_name = value;
    }

    public get ops_phone(): string {
        return this._ops_phone;
    }

    public set ops_phone(value: string) {
        this._ops_phone = value;
    }

    public get ops_email(): string {
        return this._ops_email;
    }

    public set ops_email(value: string) {
        this._ops_email = value;
    }

    public get dis_name(): string {
        return this._dis_name;
    }

    public set dis_name(value: string) {
        this._dis_name = value;
    }

    public get dis_phone(): string {
        return this._dis_phone;
    }

    public set dis_phone(value: string) {
        this._dis_phone = value;
    }

    public get dis_email(): string {
        return this._dis_email;
    }

    public set dis_email(value: string) {
        this._dis_email = value;
    }

    public get driver(): string {
        return this._driver;
    }

    public set driver(value: string) {
        this._driver = value;
    }

    public get tractor(): string {
        return this._tractor;
    }

    public set tractor(value: string) {
        this._tractor = value;
    }

    public get trailer(): string {
        return this._trailer;
    }

    public set trailer(value: string) {
        this._trailer = value;
    }

    public get sharedStops(): ModelRow[] {
        return this._sharedStops;
    }

    public set sharedStops(value: ModelRow[]) {
        this._sharedStops = value;
    }

    public get ops_ext(): string {
        return this._ops_ext;
    }

    public set ops_ext(value: string) {
        this._ops_ext = value;
    }

    public get dis_ext(): string {
        return this._dis_ext;
    }

    public set dis_ext(value: string) {
        this._dis_ext = value;
    }

    public get isBrokerage(): boolean {
        return this._isBrokerage;
    }

    public set isBrokerage(value: boolean) {
        this._isBrokerage = value;
    }

    public get driverPhone(): string {
        return this._driverPhone;
    }

    public set driverPhone(value: string) {
        this._driverPhone = value;
    }

    public get driverEmail(): string {
        return this._driverEmail;
    }

    public set driverEmail(value: string) {
        this._driverEmail = value;
    }

    public get driver2(): string {
        return this._driver2;
    }

    public set driver2(value: string) {
        this._driver2 = value;
    }

    public get driver2Phone(): string {
        return this._driver2Phone;
    }

    public set driver2Phone(value: string) {
        this._driver2Phone = value;
    }

    public get driver2Email(): string {
        return this._driver2Email;
    }

    public set driver2Email(value: string) {
        this._driver2Email = value;
    }

    public get carrierName(): string {
        return this._carrierName;
    }

    public set carrierName(value: string) {
        this._carrierName = value;
    }

    public get carrierContact(): string {
        return this._carrierContact;
    }

    public set carrierContact(value: string) {
        this._carrierContact = value;
    }

    public get carrierPhone(): string {
        return this._carrierPhone;
    }

    public set carrierPhone(value: string) {
        this._carrierPhone = value;
    }

    public get carrierEmail(): string {
        return this._carrierEmail;
    }

    public set carrierEmail(value: string) {
        this._carrierEmail = value;
    }

    public get trailerType(): string {
        return this._trailerType;
    }

    public set trailerType(value: string) {
        this._trailerType = value;
    }
}
